import { isDefined, isNil } from "@clipboard-health/util-ts";

import { type PaymentsListItemDetailed } from "../types/PaymentsListItemDetailed";

const MAX_GROSS_RECONCILIATION_DELTA_IN_CENTS = 1;

/**
 * Resolves the 1099 policy fee that can be safely surfaced in the payment
 * breakdown. The BFF stores `amountInCents` already net of the fee (subtracted
 * upstream in backend-main at `TIMESHEET_UPLOAD`), so we only display it when
 * `amount + fee` reconciles with the shift's `pay * time`; otherwise the BFF
 * assignment value is considered stale and we return undefined.
 */
export function getDisplayableTen99PolicyFeeInCents(params: {
  item: PaymentsListItemDetailed | undefined;
  ten99PolicyFeeInCents: number | undefined;
}): number | undefined {
  const { item, ten99PolicyFeeInCents } = params;

  if (
    !isDefined(item) ||
    !isDefined(ten99PolicyFeeInCents) ||
    ten99PolicyFeeInCents <= 0 ||
    item.attributes.paymentCategory !== "shift-verification" ||
    isNil(item.shift)
  ) {
    return undefined;
  }

  const expectedGrossAmountInCents = Math.round(
    item.shift.attributes.pay * item.shift.attributes.time * 100
  );
  const actualGrossAmountInCents = item.attributes.amountInCents + ten99PolicyFeeInCents;

  return Math.abs(actualGrossAmountInCents - expectedGrossAmountInCents) <=
    MAX_GROSS_RECONCILIATION_DELTA_IN_CENTS
    ? ten99PolicyFeeInCents
    : undefined;
}
